import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";

export const notificationsPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.notifications(),
    queryFn: () => fetchOccPageData<PageInitialDataResult<void>>("/page-data/notifications"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
